import * as React from "react";
import { Step, StepLabel, Stepper, Typography, Box } from "@mui/material";
import styled from "@emotion/styled";
export default function VerticalLinearStepper({ page, steps }) {
  const activePage = steps?.find((step) => step?.key === page)?.labelId;
  const StyledStepper = styled(Stepper)(({ theme }) => {
    return {
      "& .MuiStepLabel-label": {
        color: theme.palette.text.disabled,
        fontSize: 13,
        "&.Mui-completed,&.Mui-active": {
          color: theme.palette.text.secondary,
          fontWeight: 500,
        },
      },
    };
  });
  return (
    <>
      <Box>
        <Typography
          sx={{
            fontSize: 48,
            fontWeight: 700,
            display: "flex",
            width: "100%",
            alignItems: "center",
          }}
        >
          {" "}
          {steps?.find((step) => step?.key === page)?.value}
          <Typography
            sx={{ display: "inline-flex", flexDirection: "column", mx: 0.5 }}
            component={"span"}
            color={"text.secondary"}
            fontSize={24}
          >
            %
            <Typography
              component={"span"}
              color={"text.disabled"}
              fontSize={12}
            >
              Completed
            </Typography>
          </Typography>
        </Typography>
      </Box>

      <Box sx={{ marginBottom: "10%" }}>
        <StyledStepper activeStep={activePage} orientation="vertical">
          {steps?.map((step, index) => (
            <Step key={step.label}>
              <StepLabel >{step.label}</StepLabel>
            </Step>
          ))}
        </StyledStepper>
      </Box>
    </>
  );
}
